import {
    Component,
    Input,
    OnChanges,
    OnDestroy,
    SimpleChanges,
    ViewChild,
    ElementRef
} from "@angular/core";
import { PhotoService } from "../../services/photo.service";
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from "@angular/forms";
import { SharedDataService } from "../../services/shared-data.service";
import {
    ActionSheetController,
    ModalController,
    NavController,
    AlertController,
    Platform
} from "@ionic/angular";
import { StaticDataService } from "../../services/static-data.service";
import {
    MediaCapture,
    MediaFile,
    CaptureError,
    CaptureVideoOptions,
} from "@ionic-native/media-capture/ngx";
import { DomSanitizer, SafeUrl } from "@angular/platform-browser";
import { Capacitor } from "@capacitor/core";
import { FilehandlerService } from "src/app/services/filehandler.service";
import { UtilService } from "src/app/services/util.service";
import { TranslateService } from "@ngx-translate/core";
import { VideorecordPage } from "src/app/modals/videorecord/videorecord.page";
import { AndroidPermissions } from "@ionic-native/android-permissions/ngx";
import { Filesystem, Directory } from '@capacitor/filesystem';
import { Device } from '@capacitor/device';



@Component({
    selector: "app-photo-field",
    templateUrl: "./photo-field.component.html",
    styleUrls: ["./photo-field.component.scss"],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: PhotoFieldComponent,
            multi: true,
        },
    ],
})
export class PhotoFieldComponent
    implements ControlValueAccessor, OnDestroy, OnChanges {
    window = window;

    StaticDataService = StaticDataService;
    UtilService = UtilService;
    Capacitor = Capacitor;

    @Input() label: string;
    @Input() defaultValue: any;
    @Input() preValue: any;

    image: any;
    private disabled = false;

    // isVideo = false;    isVideo = false;

    videoUrl;
    attachementList = [];
    photoThumbnailList = [];
    expandedList = [];
    namesList = [];
    isVideoList =[]
    selectedFile: File | null = null;
    preValueVideoExtension: string;
    takenPhotoNumber = 1



    //photoThumbnail: any;

    isWebApp: Boolean = UtilService.isWebApp();

    private onChange: any = (image: any) => { };
    private onTouch: any = () => { };

    @ViewChild('videoFileInput') videoFileInput: ElementRef<HTMLInputElement>;

    constructor(
        public photoService: PhotoService,
        private sanitizer: DomSanitizer,
        private mediaCapture: MediaCapture,
        public navCtrl: NavController,
        public translateService: TranslateService,
        public utilService: UtilService,
        public filehandlerService: FilehandlerService,
        public sharedDataService: SharedDataService,
        public actionSheetController: ActionSheetController,
        public modalController: ModalController,
        private alertController: AlertController,
        private androidPermissions: AndroidPermissions,
        private platform: Platform


    ) { }

    ngOnInit() {
        if (this.preValue) {
            for (let i = 0; i < this.preValue.length; i++) {
                const currentPreValue = this.preValue[i];
            setTimeout(() => {
                const imageExtensions = /\.(jpg|jpeg|png|gif|bmp|webp|svg|tiff|ico)/i;
                const videoExtensions = /\.(mp4|avi|mov|wmv|flv|mkv|webm|ogg|m4v|3gp|3g2)/i;

                if (
                    imageExtensions.test(currentPreValue?.fileLink)
                ) {
                    this.savePhoto(currentPreValue.fileLink, null, currentPreValue.fileName);
                } else if(videoExtensions.test(currentPreValue?.fileLink)) {
                    if (UtilService.isWebApp() || UtilService.isLocalHost()) {
                        this.photoAdded(currentPreValue?.fileLink,null,currentPreValue?.fileName,currentPreValue?.fileLink);

                    } else {
                        (async () => {
                            try {
                                const response = await this.filehandlerService.saveFileOnDevicePath(
                                    currentPreValue?.fileLink,
                                    StaticDataService.formImagesFolderName
                                );
                                this.photoService.cleanCamera();
                                this.videoUrl = Capacitor.convertFileSrc(response as string);
                                this.photoAdded(this.videoUrl, null, currentPreValue?.fileName, this.videoUrl);
                            } catch (error) {
                                console.error("Error saving file on device path", error);
                                this.videoUrl = Capacitor.convertFileSrc(currentPreValue?.fileLink);
                                this.photoAdded(this.videoUrl, null, currentPreValue?.fileName, this.videoUrl);
                            }
                        })();
                    }
                } 
                else {
                    this.attachementList.push({attachement: currentPreValue.fileLink, name: currentPreValue.fileName});
                    this.photoThumbnailList.push(null);
                    this.expandedList.push(null);
                    this.isVideoList.push(false);
                    this.onChange(this.attachementList);
                }
            }, 1);
        }
        }
    }

    private isRemoteUrl(src: string): boolean {
        return typeof src === 'string' && /^https?:\/\//i.test(src);
    }

    private loadRemoteImageAsThumbnail(url: string, index: number | null, name: string): void {
        const ext = (name?.split('.').pop() || 'jpeg').toLowerCase().replace(/\?.*$/, '');
        const bustUrl = `${url}${url.includes('?') ? '&' : '?'}xyz=${this.utilService.getCurrentTimeStamp()}`;
        this.filehandlerService.fetchPhotoFromUrl(bustUrl, ext, name).then((file: Blob) => {
            this.utilService.generateThumbnailFromBlob(
                file,
                1920,
                1080,
                0.5,
                (data) => {
                    name = this.checkNameExtension(name, data);
                    if (index != null) {
                        this.photoThumbnailList[index] = data;
                        this.photoAdded(url, index, name);
                    } else {
                        this.photoThumbnailList.push(data);
                        this.photoAdded(url, null, name, false);
                    }
                },
            );
        }).catch((error) => {
            console.error('Error loading relaunch image', error);
        });
    }

    removeCapacitorPrefixAndroid(url) {
        const prefix1 = 'http://localhost/_capacitor_file_';
      if (url.startsWith(prefix1)) {
        url = url.substring(prefix1.length);   
      }
      return url;
    }

    async ngOnChanges(changes: SimpleChanges) {
        if (this.defaultValue) {
            setTimeout(() => {
                let savedValue = []
                let isOld =false
                if (!Array.isArray(this.defaultValue)) { 
                    isOld = true
                    this.attachementList=[]
                    savedValue.push({ attachement: this.defaultValue, name:'--'})
                }
                else {
                    savedValue = this.defaultValue; 
                }
    
                for (let i = 0; i < savedValue.length; i++) {
                    const globalCurrentValue = savedValue[i];
    
                    if (this.platform.is('android') && !globalCurrentValue?.attachement?.type) { 
                        globalCurrentValue.attachement = this.removeCapacitorPrefixAndroid(globalCurrentValue?.attachement)
                    }
                    const currentDefaultValue = globalCurrentValue?.file?globalCurrentValue?.file:globalCurrentValue?.attachement; 
                    let extension = "";
                    
                    if (currentDefaultValue?.type) {
                        extension = currentDefaultValue?.name.split('.').pop() || '';
                        this.attachementList.push(globalCurrentValue);
                        this.photoThumbnailList.push(null)   
                        this.expandedList.push(null)
                        this.isVideoList.push(false)
                    }
                    let currentName = globalCurrentValue?.name ? globalCurrentValue?.name : globalCurrentValue?.fileName || 'File name';
    
    
                    if (!currentDefaultValue?.type) {
                        if (UtilService.IsBase64Sring(currentDefaultValue)) {
                            extension = currentDefaultValue.match(/[^:/]\w+(?=;|,)/)[0];
                        } else {
                            extension = currentDefaultValue.split(".").pop().toLowerCase();
                        }
                        if (isOld) {
                            currentName = currentName + '.' + extension;
                        }
                if (
                    StaticDataService.supportedVideoFormats.indexOf(extension) !==
                    -1
                ) {
                        const startsWithAny = currentDefaultValue?.startsWith('file://') ||
                            currentDefaultValue?.startsWith('capacitor') ||
                        currentDefaultValue?.startsWith('/');
                    
                    if (UtilService.IsBase64Sring(globalCurrentValue?.attachement)) { 
                        this.photoAdded(globalCurrentValue?.attachement, null, currentName, globalCurrentValue?.attachement,isOld);
                    }
                    else if (startsWithAny) {
                            let videoUrl = Capacitor.convertFileSrc(currentDefaultValue);
                        this.photoAdded(videoUrl, null, currentName, videoUrl,isOld);
    
                    }
                    else {
                        let videoUrl = Capacitor.convertFileSrc(globalCurrentValue?.attachement+'&xyz='+this.utilService.getCurrentTimeStamp());
                        this.photoAdded(videoUrl,null, currentName ,videoUrl,isOld );
                    }
                } else {
                    this.utilService.generateThumbnailFromImage(
                        currentDefaultValue,
                        1920,
                        1080,
                        0.5,
                        (data) => {
                                this.photoThumbnailList.push(data);
                                this.photoAdded(currentDefaultValue,null,currentName,false,isOld);
                            }
                    );
                }
            }
                }
                this.onChange(this.attachementList);
            }, 0);
        }
    }      
    registerOnChange(fn: any): void {
        this.onChange = fn;
    }

    ngOnDestroy(): void {
        this.attachementList = null;
        this.photoThumbnailList = []   
        this.expandedList = [];
        this.isVideoList = [];
        this.namesList = [];
    }

    registerOnTouched(fn: any): void {
        this.onTouch = fn;
    }

    writeValue(obj: any, index = null, name = '', toDisplayVideo = null, isOld = false): void {
        if (Array.isArray(obj)) return ; 
        if (index!=null) {
            this.attachementList[index].attachement = obj;
        }
        else if (obj) {
            if (isOld) {
                this.attachementList = [{ attachement: obj, name: name }];   
                this.expandedList=[true];
                if (toDisplayVideo) {
                    this.photoThumbnailList=[null];
                }
            this.isVideoList = [toDisplayVideo];
            }
            else {
                if (name) { 
                    this.attachementList.push({ attachement: obj, name: name });
                    this.expandedList.push(true);
                    if (toDisplayVideo) {
                        this.photoThumbnailList.push(null);
                    }
                    this.isVideoList.push(toDisplayVideo);
            }
            }

        }
        this.onChange(this.attachementList);
    }

    editPhoto(index) {
        this.openImageAnnotation(Capacitor.convertFileSrc(this.attachementList[index].attachement),index);
    }

    expandImage(index) {
        this.expandedList[index]=!this.expandedList[index]
    }

    photoRemoved(index) {
        this.attachementList.splice(index, 1);
        this.photoThumbnailList.splice(index, 1);
        this.expandedList.splice(index, 1);
        this.namesList.splice(index, 1);
        this.isVideoList.splice(index, 1);
        if (this.attachementList.length === 0) { 
            this.onChange(null);
        }
        else {
            this.onChange(this.attachementList);
        }

    }

    photoAdded(photo, index = null, name = '', toDisplayVideo = null, isOld = false) {

        this.writeValue(photo, index, name, toDisplayVideo, isOld);
        this.onTouch();
    }

    async addPhotoFromCamera() {
        if(await this.checkAttatchmentLimit()){
            this.sharedDataService.isGalleryOrCameraOpened = true;
            this.photoService.takePhotoFromNativeCamera((photo) => {
                this.sharedDataService.isGalleryOrCameraOpened = false;
                this.savePhoto(photo.dataUrl,null,`camera photo ${this.takenPhotoNumber}`);
                this.takenPhotoNumber++
            });
        }
    }

    async addVideoFromCamera() {
        if (UtilService.isWebApp() || UtilService.isLocalHost()) {
            const modal = await this.modalController.create({
                component: VideorecordPage,
                showBackdrop: false,
                backdropDismiss: false,
                animated: true,
                componentProps: {},
                cssClass: "video-record-modal",
            });
            await modal.present();

            modal.onWillDismiss().then(({ data }) => {
                if (data.status) {
                    const videoData = data.data;
                    this.photoAdded(videoData,null, `camera video ${(this.attachementList.length+1)}`,videoData);
                }
            });
        } else {
            this.sharedDataService.isGalleryOrCameraOpened = true;
            const options: CaptureVideoOptions = { limit: 1, duration: 3600 };
            this.mediaCapture.captureVideo(options).then(
                (data: MediaFile[]) => {
                    this.sharedDataService.isGalleryOrCameraOpened = false;
                    const capturedFile = data[0];
                    const videoUrl = capturedFile.fullPath;
                    this.videoUrl = Capacitor.convertFileSrc(videoUrl);
                    let fileName = this.attachementList.length + 1 +'.'+ this.videoUrl?.split(".").pop()?.toLowerCase();
                    this.photoAdded(this.videoUrl,null, 'camera video '+fileName ,this.videoUrl );
                },
                (err: CaptureError) => {
                    this.sharedDataService.isGalleryOrCameraOpened = false;
                    console.error(err);
                }
            );
        }
    }

    async choosePhotoVideoOption() {
        const permissionsGranted = await this.requestPermissions();
      
        if (permissionsGranted && await this.checkAttatchmentLimit()) {
            const actionSheet = await this.actionSheetController.create({
                header: "Choose option",
                cssClass: "my-custom-class",
                buttons: [
                    {
                        text: "Photo",
                        icon: "camera-outline",
                        handler: () => {
                            this.addPhotoFromCamera();
                        },
                    },
                    {
                        text: "Video",
                        icon: "videocam-outline",
                        handler: () => {
                            this.addVideoFromCamera();
                        },
                    },
                    {
                        text: "Cancel",
                        icon: "close",
                        role: "cancel",
                        handler: () => { },
                    },
                ],
            });
            await actionSheet.present();
        } else {
            console.log('Permissions not granted or attachment limit reached');
        }
    }
    // onFileSelected(event: any): void {
    //     const file = event.target.files[0];
    //     if (file) {
    //       this.selectedFile = file;
    //     }
    // }
    
    addToAttachmentList(url: string, isVideo: boolean, name: string) {
        this.attachementList.push({ url, isVideo, name });
    }
    triggerVideoFileInput() {
        if (!UtilService.isWebApp() && !UtilService.isLocalHost()) {
            this.addPhotoFromLibrary();
        } else {
            this.videoFileInput.nativeElement.click();
        }
    }
      
    // onVideoFileSelected(event: Event) {
    //     const input = event.target as HTMLInputElement;
    //     if (!input.files || input.files.length === 0) return;

    //     const file = input.files[0];
    //     const fileName = file.name;

    //     // Create a URL for the video file to use in <video> tag
    //     const videoUrl = URL.createObjectURL(file);

    //     // Add to your attachment list and arrays
    //     this.attachementList.push({
    //         name: fileName,
    //         // Add more properties if needed
    //     });

    //     this.isVideoList.push(videoUrl); // Video source string for template
    //     this.photoThumbnailList.push(null); // No thumbnail for video (or generate one if you want)
    //     this.expandedList.push(true); // Expand to show video immediately or false if you want it collapsed

    //     // Clear file input value so same file can be uploaded again if needed
    //     input.value = '';
    // }

    onVideoFileSelected(event: Event) {
        const input = event.target as HTMLInputElement;
        if (!input.files || input.files.length === 0) return;
    
        for (const file of Array.from(input.files)) {
            const fileName = file.name;
            const videoUrl = URL.createObjectURL(file);
    
            // Store both the File object and the object URL
            this.attachementList.push({
                attachement: file,  // Store the actual File object
                url: videoUrl,      // Temporary URL for display
                isVideo: true,
                name: fileName
            });
    
            this.isVideoList.push(videoUrl);
            this.photoThumbnailList.push(null);
            this.expandedList.push(true);
        }
    
        input.value = '';
        this.onChange(this.attachementList);
    }
    
    triggerFileInput() {
        const fileInput = document.createElement('input');
        fileInput.type = 'file';
        fileInput.multiple = true
        fileInput.accept = ".xlsx,.xls,.xlsm,.xslb,.csv,.pdf,.doc,.docx,.docm,.pptx,.ppt,.pptm";
        fileInput.onchange = (event: any) => {
            if(event.target.files.length + this.attachementList.length <=20){
                for(const file of event.target.files){
                    if (file) {
                        this.attachementList.push({attachement:file,name:file.name});
                        this.photoThumbnailList.push(null)   
                        this.expandedList.push(null)
                        this.isVideoList.push(false)
                        this.onChange(this.attachementList);
                    }
                }
            } else {
                this.checkAttatchmentLimit(50)
            }
        };
        fileInput.click();
      }

    onUpload(): void { 
        const formData = new FormData();
        formData.append('file', this.selectedFile, this.selectedFile.name);
    }
    async addFileLibrary() {
        const permissionsGranted = await this.requestPermissions();
      
        // if (permissionsGranted && await this.checkAttatchmentLimit()) {
        //     const alert = await this.alertController.create({
        //         header: 'Choose Upload Option',
        //         buttons: [
        //             {
        //                 text: 'Upload File',
        //                 handler: () => {
        //                     this.triggerFileInput();
        //                 }
        //             },
        //             {
        //                 text: 'Upload Photos',
        //                 handler: () => {
        //                     this.addPhotoFromLibrary();
        //                 }
        //             },
        //             {
        //                 text: 'Upload Videos',
        //                 handler: () => {
        //                   this.triggerVideoFileInput();
        //                 }
        //             },
        //             {
        //                 text: 'Cancel',
        //                 role: 'cancel',
        //                 cssClass: 'secondary'
        //             }
        //             ]
        //         });
        //     await alert.present();
        // } else {
        //     console.log('Permissions not granted or attachment limit reached');
        // }

        if (permissionsGranted && await this.checkAttatchmentLimit()) {

            const buttons: any[] = [
              {
                text: 'Upload File',
                handler: () => {
                  this.triggerFileInput();
                }
              },
              {
                text: 'Upload Media',
                handler: () => {
                  this.addPhotoFromLibrary();
                }
              },
              {
                text: 'Cancel',
                role: 'cancel',
                cssClass: 'secondary'
              }
            ];
        
            const alert = await this.alertController.create({
              header: 'Choose Upload Option',
              buttons
            });
        
            await alert.present();
        } else {
        console.log('Permissions not granted or attachment limit reached');
        }
    }

    async requestPermissions(): Promise<boolean> {
        if (this.platform.is('android')) {
          try {
            const info = await Device.getInfo();
            const androidVersion = parseFloat(info.osVersion);
      
              if (androidVersion >= 13) {
                return true;
            } else {
              const hasReadPermission = await this.androidPermissions.checkPermission(this.androidPermissions.PERMISSION.READ_EXTERNAL_STORAGE);
              const hasWritePermission = await this.androidPermissions.checkPermission(this.androidPermissions.PERMISSION.WRITE_EXTERNAL_STORAGE);
      
              if (!hasReadPermission.hasPermission || !hasWritePermission.hasPermission) {
                const result = await this.androidPermissions.requestPermissions([
                  this.androidPermissions.PERMISSION.READ_EXTERNAL_STORAGE,
                  this.androidPermissions.PERMISSION.WRITE_EXTERNAL_STORAGE
                ]);
      
                return result.hasPermission;
              } else {
                return true;
              }
            }
          } catch (error) {
            console.error('Error requesting permissions', error);
            return false;
          }
        } else if (this.platform.is('ios')) {
          return true; 
        }
        return true;
      }
      async addPhotoFromLibrary() {
        const onPhotoVideoAdded = async (urlOrBase64Data, isVideo, name) => {   
            let extension = "";
            if (UtilService.IsBase64Sring(urlOrBase64Data)) {
                extension = urlOrBase64Data.match(/[^:/]\w+(?=;|,)/)[0];
            } else {
                extension = urlOrBase64Data.split(".").pop().toLowerCase();
                if (!extension || extension.length > 5 || extension.includes('/')) {
                    extension = name ? name.split(".").pop().toLowerCase() : '';
                }
            }
            if (isVideo) {
                if (
                    StaticDataService.supportedVideoFormats.indexOf(
                        extension
                    ) === -1
                ) {
                    this.translateService
                        .get("SHARED_TEXT.MEDIA.VIDEO_FORMAT_NOT_SUPPORTED")
                        .subscribe((res) => {
                            this.utilService.showAlert(res);
                        });
                } else {
                    const videoUrl = urlOrBase64Data;
                    if (UtilService.isWebApp() || UtilService.isLocalHost()) {
                        this.photoAdded(videoUrl, null, name, videoUrl);
                    } else {
                        try {
                            const response:any = await this.filehandlerService.saveFileOnDevicePath(
                                videoUrl,
                                StaticDataService.formImagesFolderName
                            );
                            this.photoService.cleanCamera();
                            this.videoUrl = Capacitor.convertFileSrc(response);
                            this.photoAdded(this.videoUrl, null, name, this.videoUrl);
                        } catch (error) {
                            console.error("Error saving file on device path", error);
                            this.photoService.cleanCamera();
                            this.videoUrl = Capacitor.convertFileSrc(videoUrl);
                            this.photoAdded(this.videoUrl, null, name, this.videoUrl);
                        }
                    }
                }
            } else {
                if (
                    StaticDataService.supportedImageFormats.indexOf(
                        extension
                    ) === -1
                ) {
                    this.translateService
                        .get("SHARED_TEXT.MEDIA.IMAGE_FORMAT_NOT_SUPPORTED")
                        .subscribe((res) => {
                            this.utilService.showAlert(res);
                        });
                } else {
                    this.savePhoto(urlOrBase64Data, null, name);
                }
            }
        };
    
        if (UtilService.isWebApp() || UtilService.isLocalHost()) {
            this.photoService.chooseMediaFromAlbum((result, type, name) => {
                onPhotoVideoAdded(result, type === "video", name);
            }, this.attachementList.length);
        } else {
            this.photoService.pickMultipleMedia(
                async (path, isVideo, name) => {
                    await onPhotoVideoAdded(path, isVideo, name);
                },
                this.attachementList.length
            );
        }
    }
    
    async checkAttatchmentLimit(multiUploadCount = 0){
        if(this.attachementList.length + multiUploadCount >= 20){
            this.photoService.displayLimitMessage()
            return false
        }
        return true
    }
    sanitize(url: string): SafeUrl {
        return this.sanitizer.bypassSecurityTrustUrl(url);
    }

    // Allow the Angular form control to disable this input
    setDisabledState(disabled: boolean): void {
        this.disabled = disabled;
    }

    openImageAnnotation = (photo,index) => {
        this.sharedDataService.isOpenSubScreen = true;
        this.sharedDataService.setAnnotationImage(photo);
        this.sharedDataService.onAnnotationImageDone = (image) => {
            this.savePhoto(image,index);
            this.sharedDataService.setAnnotationImage(null);
            this.sharedDataService.onAnnotationImageDone = null;
        };
        this.navCtrl.navigateForward(["/image-annotation"]);
    };
    checkNameExtension(name, data = null){
        //check if valid ext, if not try and extract ext, else default to png
        const imageExtensions = ["jpg","jpeg","png","gif","bmp","webp","svg","tiff","ico","heic","heif"];
        for(const ext of imageExtensions){
            if(name.toLowerCase().includes(ext)){
                if(ext === 'heic' || ext === 'heif'){
                    return name.replace(/\.(heic|heif)$/i, '.jpg');
                }
                return name;
            }
        }
        if(data){
            const dataTypeDec =  data.slice(0,30).split(":")[1].split(";")[0]
            if(dataTypeDec.split("/")[0] === "image"){
                for (const ext of imageExtensions){
                    if(dataTypeDec.split("/")[0] === ext){
                        if(name.includes(".")){
                            return `${name}${ext}`
                        } else{
                            return `${name}.${ext}`
                        }
                    }
                }
            }
        }
        if(name.includes(".")){
            return `${name.substring(0, name.lastIndexOf('.'))}.png`
        }else{
           return `${name}.png`
        }
    }
    async savePhoto(imageBase64, index = null, name = '') {
        if (UtilService.isWebApp() || UtilService.isLocalHost()) {
            this.utilService.generateThumbnailFromImage(
                imageBase64,
                1920,
                1080,
                0.5,
                async (data) => {
                    name = this.checkNameExtension(name, data);
                    // Upload the downscaled copy, as the native branch below does. This branch
                    // used to upload the original, so a gallery photo went up at full size
                    // (~6 MB each in CG-1534). An already-saved photo arrives here as its
                    // remote URL and is kept as-is, so it is not re-uploaded.
                    const uploadValue = this.isRemoteUrl(imageBase64) ? imageBase64 : data;
                    if (index != null) {
                        this.photoThumbnailList[index] = data;
                        this.photoAdded(uploadValue, index, name);
                    } else {
                        this.photoThumbnailList.push(data);
                        this.photoAdded(uploadValue, null, name, false);
                    }
                }
            );
        } else if (this.isRemoteUrl(imageBase64)) {
            this.loadRemoteImageAsThumbnail(imageBase64, index, name);
        } else {
            this.utilService.generateThumbnailFromImage(
                UtilService.IsBase64Sring(imageBase64)
                    ? imageBase64
                    : Capacitor.convertFileSrc(imageBase64),
                1920,
                1080,
                0.5,
                async (data) => { 
                    name = this.checkNameExtension(name, data);
                    if (index != null) {
                        this.photoThumbnailList[index] = data;
                        this.photoAdded(data, index, name);
                    } else {
                        this.photoThumbnailList.push(data);
                        this.photoAdded(data, null, name, false);
                    }
                    try {
                        const response = await this.filehandlerService.saveFileOnDevicePath(
                            imageBase64,
                            StaticDataService.formImagesFolderName
                        );
                        this.photoService.cleanCamera();
                        if (response) {
                            // this.photoAdded(response, null, name, false);
                        }
                    } catch (error) {
                        console.error("Error saving file on device path", error);
                        this.photoService.cleanCamera();
                    }
                }
            );
        }
    }
    
}
